import React, { useCallback, useContext, useState } from "react";
import { withRouter } from "react-router";
import {Dimmer, Image, Loader} from 'semantic-ui-react';
import dbApp from "./firebase";
import {AuthContext} from "./Auth";
import logo from './agrari-styles/logo 1v.png';

const createChallenge = () => {
  const first = Math.floor(Math.random() * 8) + 2;
  const second = Math.floor(Math.random() * 8) + 2;
  return {first, second, answer: first + second};
};

const SignUp = ({ history }) => {
  const {refreshCurrentUser} = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [captcha, setCaptcha] = useState(createChallenge);

  const handleSignUp = useCallback(async event => {
    event.preventDefault();
    const {clientName, ranchName, email, password, passwordConfirmation, captchaAnswer} = event.target.elements;
    setError('');
    if (password.value !== passwordConfirmation.value) {
      setError('Las contraseñas no coinciden.');
      return;
    }
    if (Number(captchaAnswer.value) !== captcha.answer) {
      setError('La respuesta de verificación es incorrecta.');
      setCaptcha(createChallenge());
      captchaAnswer.value = '';
      return;
    }
    setLoading(true);
    try {
      const credential = await dbApp
        .auth()
        .createUserWithEmailAndPassword(email.value, password.value);
      await credential.user.updateProfile({displayName: clientName.value.trim()});
      const initializeCompany = dbApp.functions('us-central1').httpsCallable('initializeCompany');
      await initializeCompany({
        name: ranchName.value.trim(),
        clientName: clientName.value.trim(),
      });
      await refreshCurrentUser();
      history.push("/");
    } catch (error) {
      setError(error.message || 'No fue posible crear la cuenta.');
      setLoading(false);
    }
  }, [captcha.answer, history, refreshCurrentUser]);

  return (
    <div className="signupPage">
      <Dimmer active={loading}><Loader>Creando tu empresa...</Loader></Dimmer>
      <section className="signupIntro">
        <Image src={logo} size="small" />
        <div>
          <h1>Empieza a llevar el control de tu rancho con Agrari</h1>
          <p>Crea tu cuenta y administra toda la operación de tu empresa agrícola desde un solo lugar.</p>
          <p>Registra actividades, cosechas, inventarios, aplicaciones de productos y el trabajo de tu personal para tener información clara y actualizada cuando la necesites.</p>
          <p className="signupTagline">Menos libretas. Menos hojas de cálculo. Más control sobre tu campo.</p>
          <div className="signupBenefits">
            <strong>Con tu cuenta podrás:</strong>
            <ul>
              <li>Centralizar la información de tu rancho.</li>
              <li>Dar seguimiento al trabajo y a los insumos.</li>
              <li>Consultar datos actualizados desde cualquier lugar.</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="signupCard">
        <h2>Crear mi cuenta</h2>
        <p className="signupCardIntro">Configura los datos principales de tu empresa agrícola. Podrás completar el resto desde Ajustes.</p>
        <form onSubmit={handleSignUp}>
          <div className="signupFieldGrid">
            <div>
              <label htmlFor="signupClientName">Nombre del dueño</label>
              <input id="signupClientName" name="clientName" type="text" placeholder="Nombre completo" maxLength="100" required />
            </div>
            <div>
              <label htmlFor="signupRanchName">Nombre del rancho</label>
              <input id="signupRanchName" name="ranchName" type="text" placeholder="Nombre de tu rancho" maxLength="100" required />
            </div>
          </div>
          <label htmlFor="signupEmail">Correo electrónico</label>
          <input id="signupEmail" name="email" type="email" placeholder="correo@ejemplo.com" required />
          <div className="signupFieldGrid">
            <div>
              <label htmlFor="signupPassword">Contraseña</label>
              <input id="signupPassword" name="password" type="password" placeholder="Mínimo 6 caracteres" minLength="6" required />
            </div>
            <div>
              <label htmlFor="signupPasswordConfirmation">Confirmar contraseña</label>
              <input id="signupPasswordConfirmation" name="passwordConfirmation" type="password" placeholder="Repite la contraseña" minLength="6" required />
            </div>
          </div>
          <div className="signupCaptcha">
            <div>
              <span>Verificación humana</span>
              <strong>¿Cuánto es {captcha.first} + {captcha.second}?</strong>
            </div>
            <input name="captchaAnswer" type="number" inputMode="numeric" aria-label="Respuesta de verificación" required />
            <button type="button" onClick={() => setCaptcha(createChallenge())} aria-label="Generar otra pregunta">Cambiar</button>
          </div>
          {error ? <p className="signupError">{error}</p> : null}
          <button className="signupSubmit" type="submit" disabled={loading}>Crear mi cuenta</button>
        </form>
        <p className="signupLogin">¿Ya tienes una cuenta? <button type="button" onClick={() => history.push('/login')}>Inicia sesión</button></p>
      </section>
    </div>
  );
};

export default withRouter(SignUp);
